import { render } from "./HelpIcon.vue?vue&type=template&id=04a49528"
import script from "./HelpIcon.vue?vue&type=script&lang=js"
export * from "./HelpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__